@file:OptIn(InternalResourceApi::class)

package partejar_app.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/partejar_app.shared.generated.resources/"

@delegate:ResourceContentHash(-1_179_905_335)
internal val Res.drawable.baby_hand_stage_1: DrawableResource by lazy {
      DrawableResource("drawable:baby_hand_stage_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/baby_hand_stage_1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_379_507_278)
internal val Res.drawable.baby_hand_stage_1_inner_life: DrawableResource by lazy {
      DrawableResource("drawable:baby_hand_stage_1_inner_life", setOf(
        ResourceItem(setOf(), "${MD}drawable/baby_hand_stage_1_inner_life.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_531_744_731)
internal val Res.drawable.baby_hand_stage_2: DrawableResource by lazy {
      DrawableResource("drawable:baby_hand_stage_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/baby_hand_stage_2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_276_565_117)
internal val Res.drawable.baby_hand_stage_2_inner_life: DrawableResource by lazy {
      DrawableResource("drawable:baby_hand_stage_2_inner_life", setOf(
        ResourceItem(setOf(), "${MD}drawable/baby_hand_stage_2_inner_life.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_824_152_470)
internal val Res.drawable.baby_hand_stage_3: DrawableResource by lazy {
      DrawableResource("drawable:baby_hand_stage_3", setOf(
        ResourceItem(setOf(), "${MD}drawable/baby_hand_stage_3.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_484_557_251)
internal val Res.drawable.baby_hand_stage_3_inner_life: DrawableResource by lazy {
      DrawableResource("drawable:baby_hand_stage_3_inner_life", setOf(
        ResourceItem(setOf(), "${MD}drawable/baby_hand_stage_3_inner_life.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_307_091_387)
internal val Res.drawable.gestacional_hero_background: DrawableResource by lazy {
      DrawableResource("drawable:gestacional_hero_background", setOf(
        ResourceItem(setOf(), "${MD}drawable/gestacional_hero_background.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(784_612_201)
internal val Res.drawable.gestacional_hero_background_2_dark: DrawableResource by lazy {
      DrawableResource("drawable:gestacional_hero_background_2_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/gestacional_hero_background_2_dark.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_093_371_984)
internal val Res.drawable.gestacional_hero_background_3_dark: DrawableResource by lazy {
      DrawableResource("drawable:gestacional_hero_background_3_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/gestacional_hero_background_3_dark.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-536_422_871)
internal val Res.drawable.gestante_stage_1_body: DrawableResource by lazy {
      DrawableResource("drawable:gestante_stage_1_body", setOf(
        ResourceItem(setOf(), "${MD}drawable/gestante_stage_1_body.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-964_483_569)
internal val Res.drawable.gestante_stage_2_body: DrawableResource by lazy {
      DrawableResource("drawable:gestante_stage_2_body", setOf(
        ResourceItem(setOf(), "${MD}drawable/gestante_stage_2_body.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(741_212_507)
internal val Res.drawable.gestante_stage_3_body: DrawableResource by lazy {
      DrawableResource("drawable:gestante_stage_3_body", setOf(
        ResourceItem(setOf(), "${MD}drawable/gestante_stage_3_body.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-10_633_354)
internal val Res.drawable.gestational_hero_stage_1_dark: DrawableResource by lazy {
      DrawableResource("drawable:gestational_hero_stage_1_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/gestational_hero_stage_1_dark.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(391_347_340)
internal val Res.drawable.gestational_hero_stage_2_dark: DrawableResource by lazy {
      DrawableResource("drawable:gestational_hero_stage_2_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/gestational_hero_stage_2_dark.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-709_567_915)
internal val Res.drawable.gestational_hero_stage_3_dark: DrawableResource by lazy {
      DrawableResource("drawable:gestational_hero_stage_3_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/gestational_hero_stage_3_dark.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-407_749_841)
internal val Res.drawable.partejar_app_icon_preview_dark: DrawableResource by lazy {
      DrawableResource("drawable:partejar_app_icon_preview_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/partejar_app_icon_preview_dark.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_318_234_454)
internal val Res.drawable.partejar_lockup_dark: DrawableResource by lazy {
      DrawableResource("drawable:partejar_lockup_dark", setOf(
        ResourceItem(setOf(), "${MD}drawable/partejar_lockup_dark.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-624_902_998)
internal val Res.drawable.partejar_lockup_dark_transparent: DrawableResource by lazy {
      DrawableResource("drawable:partejar_lockup_dark_transparent", setOf(
        ResourceItem(setOf(), "${MD}drawable/partejar_lockup_dark_transparent.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_017_661_604)
internal val Res.drawable.partejar_lockup_light: DrawableResource by lazy {
      DrawableResource("drawable:partejar_lockup_light", setOf(
        ResourceItem(setOf(), "${MD}drawable/partejar_lockup_light.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(740_964_046)
internal val Res.drawable.partejar_lockup_light_transparent: DrawableResource by lazy {
      DrawableResource("drawable:partejar_lockup_light_transparent", setOf(
        ResourceItem(setOf(), "${MD}drawable/partejar_lockup_light_transparent.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-720_491_866)
internal val Res.drawable.partejar_symbol: DrawableResource by lazy {
      DrawableResource("drawable:partejar_symbol", setOf(
        ResourceItem(setOf(), "${MD}drawable/partejar_symbol.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_778_593_738)
internal val Res.drawable.partejar_symbol_black: DrawableResource by lazy {
      DrawableResource("drawable:partejar_symbol_black", setOf(
        ResourceItem(setOf(), "${MD}drawable/partejar_symbol_black.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_253_716_693)
internal val Res.drawable.partejar_symbol_black_transparent: DrawableResource by lazy {
      DrawableResource("drawable:partejar_symbol_black_transparent", setOf(
        ResourceItem(setOf(), "${MD}drawable/partejar_symbol_black_transparent.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(439_947_868)
internal val Res.drawable.partejar_symbol_transparent: DrawableResource by lazy {
      DrawableResource("drawable:partejar_symbol_transparent", setOf(
        ResourceItem(setOf(), "${MD}drawable/partejar_symbol_transparent.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(692_832_431)
internal val Res.drawable.partejar_wordmark: DrawableResource by lazy {
      DrawableResource("drawable:partejar_wordmark", setOf(
        ResourceItem(setOf(), "${MD}drawable/partejar_wordmark.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(525_988_406)
internal val Res.drawable.partejar_wordmark_transparent: DrawableResource by lazy {
      DrawableResource("drawable:partejar_wordmark_transparent", setOf(
        ResourceItem(setOf(), "${MD}drawable/partejar_wordmark_transparent.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("baby_hand_stage_1", Res.drawable.baby_hand_stage_1)
  map.put("baby_hand_stage_1_inner_life", Res.drawable.baby_hand_stage_1_inner_life)
  map.put("baby_hand_stage_2", Res.drawable.baby_hand_stage_2)
  map.put("baby_hand_stage_2_inner_life", Res.drawable.baby_hand_stage_2_inner_life)
  map.put("baby_hand_stage_3", Res.drawable.baby_hand_stage_3)
  map.put("baby_hand_stage_3_inner_life", Res.drawable.baby_hand_stage_3_inner_life)
  map.put("gestacional_hero_background", Res.drawable.gestacional_hero_background)
  map.put("gestacional_hero_background_2_dark", Res.drawable.gestacional_hero_background_2_dark)
  map.put("gestacional_hero_background_3_dark", Res.drawable.gestacional_hero_background_3_dark)
  map.put("gestante_stage_1_body", Res.drawable.gestante_stage_1_body)
  map.put("gestante_stage_2_body", Res.drawable.gestante_stage_2_body)
  map.put("gestante_stage_3_body", Res.drawable.gestante_stage_3_body)
  map.put("gestational_hero_stage_1_dark", Res.drawable.gestational_hero_stage_1_dark)
  map.put("gestational_hero_stage_2_dark", Res.drawable.gestational_hero_stage_2_dark)
  map.put("gestational_hero_stage_3_dark", Res.drawable.gestational_hero_stage_3_dark)
  map.put("partejar_app_icon_preview_dark", Res.drawable.partejar_app_icon_preview_dark)
  map.put("partejar_lockup_dark", Res.drawable.partejar_lockup_dark)
  map.put("partejar_lockup_dark_transparent", Res.drawable.partejar_lockup_dark_transparent)
  map.put("partejar_lockup_light", Res.drawable.partejar_lockup_light)
  map.put("partejar_lockup_light_transparent", Res.drawable.partejar_lockup_light_transparent)
  map.put("partejar_symbol", Res.drawable.partejar_symbol)
  map.put("partejar_symbol_black", Res.drawable.partejar_symbol_black)
  map.put("partejar_symbol_black_transparent", Res.drawable.partejar_symbol_black_transparent)
  map.put("partejar_symbol_transparent", Res.drawable.partejar_symbol_transparent)
  map.put("partejar_wordmark", Res.drawable.partejar_wordmark)
  map.put("partejar_wordmark_transparent", Res.drawable.partejar_wordmark_transparent)
}
